/** Small, tree-shakable contracts shared by the public basic primitives. */
export const primitiveStyles = `
  :host { box-sizing: border-box; font-family: var(--qds-font-family, 'IBM Plex Sans', sans-serif);
    font-size: var(--theme-font-size-sm, 14px); line-height: var(--theme-line-height-normal, 1.5);
    color: var(--theme-text-primary, #333); }
  :host([hidden]), [hidden] { display: none !important; }
  *, *::before, *::after { box-sizing: border-box; }
  button { font: inherit; color: inherit; }
  button:focus-visible, :host(:focus-visible) { outline: 2px solid var(--theme-accent-primary, #445e89); outline-offset: 2px; }
  @media (forced-colors: active) { button:focus-visible, :host(:focus-visible) { outline-color: Highlight; } }
`;

/** Read a finite numeric attribute without allowing NaN into geometry or ARIA. */
export function numberAttribute(host: HTMLElement, name: string, fallback: number): number {
  const text = host.getAttribute(name);
  if (text === null || text.trim() === '') return fallback;
  const value = Number(text);
  return Number.isFinite(value) ? value : fallback;
}

/** An allowlist protects CSS/ARIA contracts from arbitrary attribute values. */
export function enumAttribute<T extends string>(host: HTMLElement, name: string, values: readonly T[], fallback: T): T {
  const value = host.getAttribute(name) as T;
  return values.includes(value) ? value : fallback;
}

/** Wrap through an enabled collection; callers retain the widget's key policy. */
export function rovingIndex(current: number, length: number, direction: number): number {
  return length ? (current + direction + length) % length : -1;
}

export function primitiveEvent<T>(host: HTMLElement, name: string, detail: T, cancelable = false): boolean {
  return host.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true, cancelable }));
}
